var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.0789V11.9989C21.9988 14.1553 21.3005 16.2536 20.0093 17.9807C18.7182 19.7079 16.9033 20.9714 14.8354 21.5828C12.7674 22.1942 10.5573 22.1208 8.53447 21.3735C6.51168 20.6262 4.78465 19.245 3.61096 17.436C2.43727 15.6269 1.87979 13.487 2.02168 11.3352C2.16356 9.18345 2.99721 7.13521 4.39828 5.49596C5.79935 3.85671 7.69279 2.71427 9.79619 2.23903C11.8996 1.7638 14.1003 1.98122 16.07 2.85889",
    stroke: "#32CC14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.99902L12 14.009L9 11.009",
    stroke: "#32CC14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.9691f352c4bcfc2f01aa3215de50eb68.svg";
export { ForwardRef as ReactComponent };